import * as Telecom from '@servicetitan/telecom-rtcs-client';
import appManager from '@app/appManager';
import {
  ServiceSessionCreatedEvent,
  ServiceSessionEventType,
} from '../../types/ServiceEvents';
import log from '../../lib/log';
import { getSession } from '../../lib/sessions';
import getTenantId from '../../lib/getTenantId';
import { serviceState } from '../../lib/state';

async function handleSessionCreated(event: Telecom.SessionCreatedEvent) {
  log('rtcs:session:created', event);

  const session = getSession(event.conversationId);
  if (session) {
    console.warn('session already exists', event.conversationId);
    return;
  }

  serviceState.sessions[event.conversationId] = {
    ...event,
    createdAt: Date.now(),
    tenantId: getTenantId(event.tenantId),
  };

  appManager.events.emit<ServiceSessionCreatedEvent>(
    ServiceSessionEventType.CREATED,
    {
      sessionId: event.conversationId,
      sessionSid: event.conversationSid,
      from: event.source.address,
      displayName: event.source.displayName ?? '',
      tenantId: getTenantId(event.tenantId),
    },
  );
}

export default handleSessionCreated;
